export class Service {
  _httpClient;
  _url;
  _middleware;
  _lastGetAll;
  _lastGet;

  get lastGetAll () {
    return this._lastGetAll
  }

  get lastGet () {
    return this._lastGet
  }

  constructor (url, httpClient, middleware) {
    this._url = url
    this._httpClient = httpClient
    this._middleware = middleware
    this._lastGet = null
    this._lastGetAll = {
      items: [],
      totalItems: 0,
      page: 0,
      totalPages: 0
    }
  }

  /**
   * @param {String | Number} id
   *
   * @returns {Promise<object>}
  */
  find (id) {
    const item = this._lastGetAll.items.find(x => `${x.id}` === `${id}`)

    if (item) {
      return Promise.resolve(item)
    }

    return this.get(id)
  }

  /**
   * @param {String | Number} id
   * @param {object} get
   * @param {String} accept
   *
   * @returns {Promise<object>}
  */
  get (id, get, accept) {
    return this._httpClient.get(`${this._url}/${id}`, get, accept)
      .then(item => {
        this._lastGet = item
        return item
      })
  }

  /**
   * @param {object} query
   * @param {String} accept
   *
   * @returns {Promise<object>}
   */
  getAll (query, accept) {
    return this._httpClient.get(this._url, query, accept)
      .then(this._middleware)
      .then(data => {
        this._lastGetAll = data
        return data
      })
  }

  /**
   * @param {object} data
   * @param {String | Number | undefined} id
   * @param {object | undefined} headers
   * @param {object | undefined} query
   *
   * @returns {Promise<object>}
   */
  save (data, id, headers, query = {}) {
    return this._httpClient.saveRequest(this._url, data, id, undefined, undefined, headers, query)
  }
}

export class ItemsService {
  _httpClient;
  _url;
  _qs;

  constructor (url, httpClient, qs) {
    this._url = url
    this._httpClient = httpClient
    this._qs = qs
  }

  /**
   * @param {object} query
   *
   * @returns {Promise<object>}
  */
  getAll (query) {
    return this._httpClient.get(this._url, query)
  }

  /**
   * Patch Items from Sorting
   *
   * @param {number} id
   * @param {object} data
   * @param {object} query
   *
   * @returns {Promise<object>}
  */
  patch (id, data, query = {}) {
    const url = `${this._url}/${id}${Object.keys(query).length > 0 ? '?' + this._qs.stringify(query) : ''}`
    return this._httpClient.patch(url, data)
  }
}

export class QueueService {
  _httpClient
  _url
  _qs
  _middleware

  constructor (url, httpClient, middleware, qs) {
    this._url = url
    this._httpClient = httpClient
    this._middleware = middleware
    this._qs = qs
  }

  /**
   * @param {String | Number} id
   *
   * @returns {Promise<object>}
   */
  get (id) {
    return this._httpClient.get(`${this._url}/${id}`)
  }

  /**
   * @param {object} query
   *
   * @returns {Promise<object>}
   */
  getAll (query) {
    return this._httpClient.get(this._url, query)
      .then(this._middleware)
  }

  /**
   * @param {String | Number | Undefined} id
   * @param {object} data
   * @param {object} query
   *
   * @returns {Promise<object>}
   */
  process (id, data, query = {}) {
    return this._httpClient.post(`${this._url}/${id}` + (Object.keys(query).length > 0 ? '?' + this._qs.stringify(query) : ''), data)
  }
}
